var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"w-fav",attrs:{"size":"mini","type":"primary"},on:{"click":_vm.doFav}},[_c('i',{class:_vm.favorite ? 'el-icon-star-on' : 'el-icon-star-off'}),_c('span',[_vm._v(_vm._s(_vm.favorite ? "取消收藏" : "收藏"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }